import { useMutation, useQueryClient } from '@tanstack/react-query'
import irisApi from '../lib/api'
import type { UploadSession } from '../types'

export function useDeleteFile(token: string, isDemo = false) {
  const queryClient = useQueryClient()

  return useMutation<void, Error, string>({
    mutationFn: (fileUuid) => {
      if (isDemo) {
        return new Promise<void>((resolve) => {
          setTimeout(() => {
            queryClient.setQueryData<UploadSession>(
              ['upload-session', token],
              (old) => {
                if (!old) return old
                return {
                  ...old,
                  slots: old.slots.map((s) => ({
                    ...s,
                    uploads: s.uploads.filter((u) => u.uuid !== fileUuid),
                  })),
                }
              },
            )
            resolve()
          }, 300)
        })
      }
      return irisApi.delete(`/${token}/files/${fileUuid}/`).then(() => undefined)
    },
    onSuccess: () => {
      if (!isDemo) {
        queryClient.invalidateQueries({ queryKey: ['upload-session', token] })
      }
    },
  })
}
